export const BILLING_PERIODS = {
  BASIC: 'basic',
  TWO_MONTHS: 'twoMonths'
} as const;
export type Periods = (typeof BILLING_PERIODS)[keyof typeof BILLING_PERIODS];